import { useState } from "react";
import PropTypes from "prop-types";
import { Row, Col, Carousel } from "react-bootstrap";

import { StrategyCard } from "shared/StrategyCard";
import { isLoggedIn } from "utils";
import { useNavigation } from "utils/navigate";
import { Card } from "components/Card";
import { IconNext, IconPrev } from "assets/icons";
import { Button } from "components/Button";
import { StrategyModalContainer } from "./RecommendStrategyResultModal.styles";
import RecommendedModalHeader from "../ModalHeader";

const RecommendStrategyResultModal = ({
  show,
  onHide,
  handleReviewAgain,
  handleDone,
  strategies,
}) => {
  const { navigateToV2MarketplaceDetail, navigateToV2Signin } = useNavigation();

  const [activeIndex, setActiveIndex] = useState(0);

  const navigateToDetail = (id) => () => {
    if (!isLoggedIn()) {
      navigateToV2Signin();
      return;
    }
    navigateToV2MarketplaceDetail(id);
  };

  const handleChangeSlider = (selectedIndex) => {
    setActiveIndex(selectedIndex);
  };

  return (
    <StrategyModalContainer
      heading=""
      show={show}
      onHide={onHide}
      centered={false}
    >
      <RecommendedModalHeader />

      <div className="content-wrapper">
        <div className="container">
          <div className="carousel-wrapper">
            <Carousel
              activeIndex={activeIndex}
              onSelect={handleChangeSlider}
              slide={false}
              interval={null}
              nextIcon={<IconNext />}
              prevIcon={<IconPrev />}
            >
              {strategies?.map((strategy, index) => (
                <Carousel.Item
                  key={`strategy-${index}`}
                  className="strategies-subwrapper"
                >
                  <StrategyCard
                    data={strategy}
                    handleCardClick={navigateToDetail(strategy?.strategy_id)}
                  />
                </Carousel.Item>
              ))}
            </Carousel>
          </div>
          <Card className="strategy-description mb-4">
            <h5 className="heading">Strategy Description</h5>
            <span>{strategies[activeIndex]?.description}</span>
          </Card>
        </div>

        <Row className="button-wrapper">
          <Col>
            <Button
              onClick={handleReviewAgain}
              className="w-100 button-outlined"
            >
              Review Again
            </Button>
          </Col>
          <Col>
            <Button type="submit" className="w-100" onClick={handleDone}>
              Done
            </Button>
          </Col>
        </Row>
      </div>
    </StrategyModalContainer>
  );
};

RecommendStrategyResultModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  handleDone: PropTypes.func,
  handleReviewAgain: PropTypes.func,
  strategies: PropTypes.array,
};

export { RecommendStrategyResultModal };
